module.exports = __webpack_public_path__ + "static/media/develop2.ac772692.png";